import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc, query, where, Timestamp } from "firebase/firestore";
import { db } from "./firebaseConfig";

const FEEDBACK_COLLECTION = "feedback";

export type FeedbackStatus = 'open' | 'resolved';

export interface FeedbackData {
  title: string;
  description: string;
  page: string;
  imageUrl: string | null;
  imagePath: string | null;
  reportedBy: string;
  reportedByUsername: string;
  userAgent: string;
  currentUrl: string;
  status: FeedbackStatus;
  createdAt: Timestamp;
  resolvedAt: Timestamp | null;
}

export type SavedFeedback = FeedbackData & { id: string };

export async function submitFeedback(data: {
  title: string;
  description: string;
  page: string;
  reportedBy: string;
  reportedByUsername: string;
  userAgent: string;
  currentUrl: string;
}): Promise<string> {
  const feedbackData: FeedbackData = {
    ...data,
    imageUrl: null,
    imagePath: null,
    status: 'open',
    createdAt: Timestamp.now(),
    resolvedAt: null,
  };

  const docRef = await addDoc(collection(db, FEEDBACK_COLLECTION), feedbackData);
  return docRef.id;
}

export async function getFeedback(statusFilter?: FeedbackStatus): Promise<SavedFeedback[]> {
  const q = statusFilter
    ? query(collection(db, FEEDBACK_COLLECTION), where("status", "==", statusFilter))
    : query(collection(db, FEEDBACK_COLLECTION));

  const snapshot = await getDocs(q);
  const items = snapshot.docs.map(d => ({ id: d.id, ...d.data() } as SavedFeedback));
  return items.sort((a, b) => b.createdAt.toMillis() - a.createdAt.toMillis());
}

export async function resolveFeedback(id: string): Promise<void> {
  const docRef = doc(db, FEEDBACK_COLLECTION, id);
  await updateDoc(docRef, { status: 'resolved', resolvedAt: Timestamp.now() });
}

export async function deleteFeedback(feedback: SavedFeedback): Promise<void> {
  await deleteDoc(doc(db, FEEDBACK_COLLECTION, feedback.id));
}
